import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/svg/quiz/quiz-finish-stage.svg?data'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Boom! Made it!"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Finish")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_QuizCard = _resolveComponent("QuizCard")!

  return (_openBlock(), _createBlock(_component_QuizCard, {
    title: "Boom! Made it!",
    description: "All finished. You did great. 5 gold stars. Your responses help us create a connected workspace for you and your team 💛",
    prev: false,
    "onQuizNavigation:close": _cache[0] || (_cache[0] = ($event: any) => (_ctx.QuizService.close())),
    class: "quiz-finish-stage",
    "is-vertically-aligned": true
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_AppButton, {
        onClick: _ctx.finishQuizAction,
        loading: _ctx.QuizService.isSaving()
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["onClick", "loading"])
    ]),
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}